import React from "react";
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { permission } from "./static/permission";
import { route } from "./static/route";

import LoginPage from "./pages/login";
import NotFoundPage from "./pages/notFound";
import DashboardPage from "./pages/dashboard";
import PrivateRoute from "./components/route/PrivateRoute";
import ItemsPage from "./pages/items";
import ItemCreatePage from "./pages/items/create";
import ItemEditPage from "./pages/items/edit";
import MaterialsPage from "./pages/materials";
import CategoriesPage from "./pages/categories";
import PartiesPage from "./pages/parties";
import PartyDetailPage from "./pages/parties/detail";
import PartyRatesPage from "./pages/parties/rates";
import PaymentsPage from "./pages/payments";
import MaterialOrdersPage from "./pages/materialOrders";
import MaterialOrderCreatePage from "./pages/materialOrders/create";
import MaterialOrderEditPage from "./pages/materialOrders/edit";
import MaterialOrderDetailPage from "./pages/materialOrders/detail";
import MaterialPurchasesPage from "./pages/materialPurchases";
import MaterialPurchaseCreatePage from "./pages/materialPurchases/create";
import MaterialPurchaseEditPage from "./pages/materialPurchases/edit";
import MaterialPurchaseDetailPage from "./pages/materialPurchases/detail";
import MaterialStockDetailPage from "./pages/materialStocks/detail";
import CuttingOrdersPage from "./pages/cuttingOrders";
import CuttingOrderCreatePage from "./pages/cuttingOrders/create";
import CuttingOrderEditPage from "./pages/cuttingOrders/edit";
import CuttingOrderDetailPage from "./pages/cuttingOrders/detail";
import CuttingReceivesPage from "./pages/cuttingReceives";
import CuttingReceiveCreatePage from "./pages/cuttingReceives/create";
import CuttingReceiveEditPage from "./pages/cuttingReceives/edit";
import CuttingReceiveDetailPage from "./pages/cuttingReceives/detail";
import TurningOrdersPage from "./pages/turningOrders";
import TurningOrderCreatePage from "./pages/turningOrders/create";
import TurningOrderEditPage from "./pages/turningOrders/edit";
import TurningOrderDetailPage from "./pages/turningOrders/detail";
import TurningReceivesPage from "./pages/turningReceives";
import TurningReceiveCreatePage from "./pages/turningReceives/create";
import TurningReceiveEditPage from "./pages/turningReceives/edit";
import TurningReceiveDetailPage from "./pages/turningReceives/detail";
import VmcOrdersPage from "./pages/vmcOrders";
import VmcOrderCreatePage from "./pages/vmcOrders/create";
import VmcOrderEditPage from "./pages/vmcOrders/edit";
import VmcOrderDetailPage from "./pages/vmcOrders/detail";
import VmcReceivesPage from "./pages/vmcReceives";
import VmcReceiveCreatePage from "./pages/vmcReceives/create";
import VmcReceiveEditPage from "./pages/vmcReceives/edit";
import VmcReceiveDetailPage from "./pages/vmcReceives/detail";
import UsersPage from "./pages/users";
import AccountsPage from "./pages/accounts";
import EmployeesPage from "./pages/employees";
import SalariesPage from "./pages/salaries";
import ActivityLogsPage from "./pages/activityLogs";
import ProfilePage from "./pages/profile";
import SettingsPage from "./pages/settings";
import BusinessReportPage from "./pages/businessReport";
import ForbiddenPage from "./pages/forbidden";

const App = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path={route.login} element={<LoginPage />} />

        <Route
          path={route.dashboard}
          element={
            <PrivateRoute element={<DashboardPage />} path={route.login} />
          }
        />

        <Route
          path={route.items}
          element={
            <PrivateRoute
              element={<ItemsPage />}
              path={route.login}
              permission={permission.itemsRead}
            />
          }
        />

        <Route
          path={route.itemCreate}
          element={
            <PrivateRoute
              element={<ItemCreatePage />}
              path={route.login}
              permission={permission.itemsCreate}
            />
          }
        />

        <Route
          path={route.itemEdit}
          element={
            <PrivateRoute
              element={<ItemEditPage />}
              path={route.login}
              permission={permission.itemsUpdate}
            />
          }
        />

        <Route
          path={route.materials}
          element={
            <PrivateRoute
              element={<MaterialsPage />}
              path={route.login}
              permission={permission.materialsRead}
            />
          }
        />

        <Route
          path={route.materialStockDetail}
          element={
            <PrivateRoute
              element={<MaterialStockDetailPage />}
              path={route.login}
              permission={permission.materialStocksRead}
            />
          }
        />

        <Route
          path={route.categories}
          element={
            <PrivateRoute
              element={<CategoriesPage />}
              path={route.login}
              permission={permission.categoriesRead}
            />
          }
        />

        <Route
          path={route.parties}
          element={
            <PrivateRoute
              element={<PartiesPage />}
              path={route.login}
              permission={permission.partiesRead}
            />
          }
        />

        <Route
          path={route.partyDetail}
          element={
            <PrivateRoute
              element={<PartyDetailPage />}
              path={route.login}
              permission={permission.partiesRead}
            />
          }
        />

        <Route
          path={route.partyRates}
          element={
            <PrivateRoute
              element={<PartyRatesPage />}
              path={route.login}
              permission={permission.partiesItems}
            />
          }
        />

        <Route
          path={route.payments}
          element={
            <PrivateRoute
              element={<PaymentsPage />}
              path={route.login}
              permission={permission.paymentsRead}
            />
          }
        />

        <Route
          path={route.materialOrderCreate}
          element={
            <PrivateRoute
              element={<MaterialOrderCreatePage />}
              path={route.login}
              permission={permission.materialOrdersCreate}
            />
          }
        />

        <Route
          path={route.materialOrderEdit}
          element={
            <PrivateRoute
              element={<MaterialOrderEditPage />}
              path={route.login}
              permission={permission.materialOrdersUpdate}
            />
          }
        />

        <Route
          path={route.materialOrders}
          element={
            <PrivateRoute
              element={<MaterialOrdersPage />}
              path={route.login}
              permission={permission.materialOrdersRead}
            />
          }
        />

        <Route
          path={route.materialOrderDetail}
          element={
            <PrivateRoute
              element={<MaterialOrderDetailPage />}
              path={route.login}
              permission={permission.materialOrdersRead}
            />
          }
        />

        <Route
          path={route.materialPurchaseCreate}
          element={
            <PrivateRoute
              element={<MaterialPurchaseCreatePage />}
              path={route.login}
              permission={permission.materialPurchasesCreate}
            />
          }
        />

        <Route
          path={route.materialPurchaseEdit}
          element={
            <PrivateRoute
              element={<MaterialPurchaseEditPage />}
              path={route.login}
              permission={permission.materialPurchasesUpdate}
            />
          }
        />

        <Route
          path={route.materialPurchases}
          element={
            <PrivateRoute
              element={<MaterialPurchasesPage />}
              path={route.login}
              permission={permission.materialPurchasesRead}
            />
          }
        />

        <Route
          path={route.materialPurchaseDetail}
          element={
            <PrivateRoute
              element={<MaterialPurchaseDetailPage />}
              path={route.login}
              permission={permission.materialPurchasesRead}
            />
          }
        />

        <Route
          path={route.cuttingOrderCreate}
          element={
            <PrivateRoute
              element={<CuttingOrderCreatePage />}
              path={route.login}
              permission={permission.cuttingOrdersCreate}
            />
          }
        />

        <Route
          path={route.cuttingOrderEdit}
          element={
            <PrivateRoute
              element={<CuttingOrderEditPage />}
              path={route.login}
              permission={permission.cuttingOrdersUpdate}
            />
          }
        />

        <Route
          path={route.cuttingOrders}
          element={
            <PrivateRoute
              element={<CuttingOrdersPage />}
              path={route.login}
              permission={permission.cuttingOrdersRead}
            />
          }
        />

        <Route
          path={route.cuttingOrderDetail}
          element={
            <PrivateRoute
              element={<CuttingOrderDetailPage />}
              path={route.login}
              permission={permission.cuttingOrdersRead}
            />
          }
        />

        <Route
          path={route.cuttingReceiveCreate}
          element={
            <PrivateRoute
              element={<CuttingReceiveCreatePage />}
              path={route.login}
              permission={permission.cuttingReceivesCreate}
            />
          }
        />

        <Route
          path={route.cuttingReceiveEdit}
          element={
            <PrivateRoute
              element={<CuttingReceiveEditPage />}
              path={route.login}
              permission={permission.cuttingReceivesUpdate}
            />
          }
        />

        <Route
          path={route.cuttingReceives}
          element={
            <PrivateRoute
              element={<CuttingReceivesPage />}
              path={route.login}
              permission={permission.cuttingReceivesRead}
            />
          }
        />

        <Route
          path={route.cuttingReceiveDetail}
          element={
            <PrivateRoute
              element={<CuttingReceiveDetailPage />}
              path={route.login}
              permission={permission.cuttingReceivesRead}
            />
          }
        />

        <Route
          path={route.turningOrderCreate}
          element={
            <PrivateRoute
              element={<TurningOrderCreatePage />}
              path={route.login}
              permission={permission.turningOrdersCreate}
            />
          }
        />

        <Route
          path={route.turningOrderEdit}
          element={
            <PrivateRoute
              element={<TurningOrderEditPage />}
              path={route.login}
              permission={permission.turningOrdersUpdate}
            />
          }
        />

        <Route
          path={route.turningOrders}
          element={
            <PrivateRoute
              element={<TurningOrdersPage />}
              path={route.login}
              permission={permission.turningOrdersRead}
            />
          }
        />

        <Route
          path={route.turningOrderDetail}
          element={
            <PrivateRoute
              element={<TurningOrderDetailPage />}
              path={route.login}
              permission={permission.turningOrdersRead}
            />
          }
        />

        <Route
          path={route.turningReceiveCreate}
          element={
            <PrivateRoute
              element={<TurningReceiveCreatePage />}
              path={route.login}
              permission={permission.turningReceivesCreate}
            />
          }
        />

        <Route
          path={route.turningReceiveEdit}
          element={
            <PrivateRoute
              element={<TurningReceiveEditPage />}
              path={route.login}
              permission={permission.turningReceivesUpdate}
            />
          }
        />

        <Route
          path={route.turningReceives}
          element={
            <PrivateRoute
              element={<TurningReceivesPage />}
              path={route.login}
              permission={permission.turningReceivesRead}
            />
          }
        />

        <Route
          path={route.turningReceiveDetail}
          element={
            <PrivateRoute
              element={<TurningReceiveDetailPage />}
              path={route.login}
              permission={permission.turningReceivesRead}
            />
          }
        />

        <Route
          path={route.vmcOrderCreate}
          element={
            <PrivateRoute
              element={<VmcOrderCreatePage />}
              path={route.login}
              permission={permission.vmcOrdersCreate}
            />
          }
        />

        <Route
          path={route.vmcOrderEdit}
          element={
            <PrivateRoute
              element={<VmcOrderEditPage />}
              path={route.login}
              permission={permission.vmcOrdersUpdate}
            />
          }
        />

        <Route
          path={route.vmcOrders}
          element={
            <PrivateRoute
              element={<VmcOrdersPage />}
              path={route.login}
              permission={permission.vmcOrdersRead}
            />
          }
        />

        <Route
          path={route.vmcOrderDetail}
          element={
            <PrivateRoute
              element={<VmcOrderDetailPage />}
              path={route.login}
              permission={permission.vmcOrdersRead}
            />
          }
        />

        <Route
          path={route.vmcReceiveCreate}
          element={
            <PrivateRoute
              element={<VmcReceiveCreatePage />}
              path={route.login}
              permission={permission.vmcReceivesCreate}
            />
          }
        />

        <Route
          path={route.vmcReceiveEdit}
          element={
            <PrivateRoute
              element={<VmcReceiveEditPage />}
              path={route.login}
              permission={permission.vmcReceivesUpdate}
            />
          }
        />

        <Route
          path={route.vmcReceives}
          element={
            <PrivateRoute
              element={<VmcReceivesPage />}
              path={route.login}
              permission={permission.vmcReceivesRead}
            />
          }
        />

        <Route
          path={route.vmcReceiveDetail}
          element={
            <PrivateRoute
              element={<VmcReceiveDetailPage />}
              path={route.login}
              permission={permission.vmcReceivesRead}
            />
          }
        />

        <Route
          path={route.users}
          element={
            <PrivateRoute
              element={<UsersPage />}
              path={route.login}
              permission={permission.usersRead}
            />
          }
        />

        <Route
          path={route.accounts}
          element={
            <PrivateRoute
              element={<AccountsPage />}
              path={route.login}
              permission={permission.accountsRead}
            />
          }
        />

        <Route
          path={route.employees}
          element={
            <PrivateRoute
              element={<EmployeesPage />}
              path={route.login}
              permission={permission.employeesRead}
            />
          }
        />

        <Route
          path={route.salaries}
          element={
            <PrivateRoute
              element={<SalariesPage />}
              path={route.login}
              permission={permission.salariesRead}
            />
          }
        />

        <Route
          path={route.activityLogs}
          element={
            <PrivateRoute
              element={<ActivityLogsPage />}
              path={route.login}
              permission={permission.activityLogsRead}
            />
          }
        />

        <Route
          path={route.businessReport}
          element={
            <PrivateRoute
              element={<BusinessReportPage />}
              path={route.login}
              permission={permission.businessReportsRead}
            />
          }
        />

        <Route
          path={route.profile}
          element={<PrivateRoute element={<ProfilePage />} path={route.login} />}
        />

        <Route
          path={route.settings}
          element={
            <PrivateRoute
              element={<SettingsPage />}
              path={route.login}
              permission={permission.settingsRead}
            />
          }
        />

        <Route
          path={route.forbidden}
          element={
            <PrivateRoute element={<ForbiddenPage />} path={route.login} />
          }
        />

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AuthProvider>
  );
};
export default App;
